import { StyleSheet } from 'react-native';

import { Color, FontFamily, FontSize } from '@/styles/GlobalStyles';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: 16,
    width: '100%',
    flexWrap: 'wrap',
  },
  containerMobile: {
    flexDirection: 'column',
    gap: 12,
  },
  cardContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    flex: 1,
    minWidth: 200,
    minHeight: 120,
    padding: 20,
    borderRadius: 12,
    backgroundColor: Color.gray.white,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
    elevation: 2,
  },
  cardContainerMobile: {
    width: '100%',
    flex: 0,
  },
  number: {
    color: Color.gray[400],
    fontFamily: FontFamily.robotoRegular,
    fontSize: FontSize['2_125xl'],
    lineHeight: 36,
  },
  label: {
    color: Color.gray[200],
    fontSize: FontSize.sm,
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'center',
  },
});
